// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RtWn","content":"styles_content__3X9L6"};